import { render, staticRenderFns } from "./price-market-price.vue?vue&type=template&id=a86b18b6&scoped=true&"
import script from "./price-market-price.vue?vue&type=script&lang=js&"
export * from "./price-market-price.vue?vue&type=script&lang=js&"
import style0 from "./price-market-price.vue?vue&type=style&index=0&id=a86b18b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86b18b6",
  null
  
)

export default component.exports